import { cva } from '@/styled-system/css';

export const navigationItemStyles = cva({
  base: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '{spacing.200} {spacing.300}',
    height: '1000',
    borderRadius: 'obj.soft',
    '&:focus-visible': {
      backgroundColor: 'bg.action.neutral.alt.hover',
      outline: '2px solid {colors.border.accent.brand.hero}',
      outlineOffset: '-2px',
    },
  },
  variants: {
    isActive: {
      true: {
        color: 'text.accent.brand.hero',
        backgroundColor: 'bg.action.neutral.alt.hover',
      },
      false: {
        color: 'text.neutral',
        _hover: {
          backgroundColor: 'bg.action.neutral.alt.hover',
        },
        _active: {
          backgroundColor: 'bg.action.soft.hover',
        },
      },
    },
  },
});
